import { WalletContext, useWallet, useAsyncEffect } from '@/services';
import { createERC20Controller } from '@/services/contracts-controller';
import { fmtBigNumber, formatCurrency } from '@/utils';
import { ReactElement, useMemo, useState } from 'react';
import _ from 'lodash';
import TokenPrecision, { DefaultPrecision } from '@/services/token-precision';
import { useGetContractAddress } from '@/services/contracts';
import { BigNumber } from 'ethers';
declare interface TokenBalanceProp {
    token: string;
    tokenAddress?: string;
    precision?: number;
    onChange?: (balance: bigint) => void;
    refresh?: number;
}
const LoadingText = '...';
const TokenBalanceFmt = (props: TokenBalanceProp): ReactElement => {
    const [balance, setBalance] = useState(LoadingText);
    const { address } = useWallet();
    const tokenAddress = useGetContractAddress(props.token);
    const precision = useMemo(() => {
        if (props.precision != undefined) {
            return props.precision;
        }
        if (!WalletContext.Chain) {
            return DefaultPrecision;
        }
        const pp = _.find(TokenPrecision[WalletContext.Chain.name], { address: tokenAddress });
        return pp === undefined ? DefaultPrecision : pp.precision;
    }, [props.precision, tokenAddress]);
    useAsyncEffect(
        async () => {
            const onChange = props.onChange ? props.onChange : _.noop;
            const erc20Controller = createERC20Controller(tokenAddress);
            if (!erc20Controller) {
                onChange(BigNumber.from('0'));
                return LoadingText;
            }
            const balanceOf = await erc20Controller.balanceOf(WalletContext.Address);
            onChange(balanceOf);
            return formatCurrency(Number(fmtBigNumber(balanceOf, precision)));
        },
        setBalance,
        [precision, props.onChange, tokenAddress, address, props.refresh],
        { ignoreNull: false }
    );
    return <>{balance}</>;
};

export default TokenBalanceFmt;
